"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[506],{

/***/ 1081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleArticle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);




dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("fr");
function SingleArticle(param) {
    let { data , link  } = param;
    var _data_attributes_preview_image_data_, _data_attributes, _data_attributes_preview_image, _data_attributes_preview_image_data__attributes, _data_attributes_tags_data_, _data_attributes_tags, _data_attributes1, _data_attributes2, _data_attributes3, _data_attributes4, _data_attributes5;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "recommendation_article",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                data.attributes.preview_image.data != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (_data_attributes_preview_image_data_ = (_data_attributes = data.attributes) === null || _data_attributes === void 0 ? void 0 : (_data_attributes_preview_image = _data_attributes.preview_image) === null || _data_attributes_preview_image === void 0 ? void 0 : _data_attributes_preview_image.data[0]) === null || _data_attributes_preview_image_data_ === void 0 ? void 0 : (_data_attributes_preview_image_data__attributes = _data_attributes_preview_image_data_.attributes) === null || _data_attributes_preview_image_data__attributes === void 0 ? void 0 : _data_attributes_preview_image_data__attributes.url
                }) : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: (_data_attributes_tags_data_ = (_data_attributes_tags = data.attributes.tags) === null || _data_attributes_tags === void 0 ? void 0 : _data_attributes_tags.data[0]) === null || _data_attributes_tags_data_ === void 0 ? void 0 : _data_attributes_tags_data_.attributes.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(link, "/").concat(data === null || data === void 0 ? void 0 : (_data_attributes1 = data.attributes) === null || _data_attributes1 === void 0 ? void 0 : _data_attributes1.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        children: data === null || data === void 0 ? void 0 : (_data_attributes2 = data.attributes) === null || _data_attributes2 === void 0 ? void 0 : _data_attributes2.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "article_info",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: data === null || data === void 0 ? void 0 : (_data_attributes3 = data.attributes) === null || _data_attributes3 === void 0 ? void 0 : _data_attributes3.author
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: dayjs__WEBPACK_IMPORTED_MODULE_3___default()((_data_attributes4 = data.attributes) === null || _data_attributes4 === void 0 ? void 0 : _data_attributes4.publishedAt).format("DD MMMM YYYY")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: data === null || data === void 0 ? void 0 : (_data_attributes5 = data.attributes) === null || _data_attributes5 === void 0 ? void 0 : _data_attributes5.description
                })
            ]
        })
    }, data === null || data === void 0 ? void 0 : data.id);
}


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Storifyme; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_helpers_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7104);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




function Storifyme(param) {
    let { className , widgetID  } = param;
    //const local = useAtomValue(localeAtom);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://cdn.storifyme.com/static/web-components/storifyme-elements.min.js";
        script.async = true;
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }, []);
    if (!widgetID) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("storifyme-collection", {
        account: "g-matthias-riverti-38614",
        widget: widgetID,
        env: "eu",
        className: className
    });
}


/***/ }),

/***/ 7506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ PLASMIC; }
});

// EXTERNAL MODULE: ./node_modules/@plasmicapp/loader-nextjs/dist/index.esm.js
var index_esm = __webpack_require__(6507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(8945);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 47 modules
var esm = __webpack_require__(7561);
;// CONCATENATED MODULE: ./components/PriceSlider/PriceSlider.js





function PriceSlider(param) {
    let { backgroundColor  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [frequency, setFrequency] = (0,react.useState)([]);
    const [economies, setEconomies] = (0,react.useState)([]);
    const [lang, setLang] = (0,react.useState)("");
    const [slider1Value, setSlider1Value] = (0,react.useState)(2);
    const [slider2Value, setSlider2Value] = (0,react.useState)(1);
    const [economyValue, setEconomyValue] = (0,react.useState)(3.8);
    const [economylabel, setEconomyLabel] = (0,react.useState)(3);
    const [frequencyValue, setFrequencyValue] = (0,react.useState)(2);
    const economyRef = (0,react.useRef)();
    const frequencyRef = (0,react.useRef)();
    const minEconomy = 0;
    const maxEconomy = 4;
    const minFrequency = 0;
    const maxFrequency = 2;
    (0,react.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    (0,react.useEffect)(()=>{
        Promise.all([
            axios/* default.get */.Z.get("".concat("https://strapi-staging.benebono.fr", "/api/person-economies?locale=").concat(lang === "es" ? "es" : "fr-FR")),
            axios/* default.get */.Z.get("".concat("https://strapi-staging.benebono.fr", "/api/frequency-monthlies?locale=").concat(lang === "es" ? "es" : "fr-FR"))
        ]).then((response)=>{
            setEconomies(response[0].data.data);
            setFrequency(response[1].data.data);
        }).catch((error)=>{
            console.log(error);
        });
    }, [
        lang
    ]);
    if (!economies && !frequency) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "Loading..."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: "price_slider_container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "slider_title",
                        children: t("price.slider.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: t("price.slider.people.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        style: {
                            backgroundSize: (parseInt(slider1Value) - minEconomy) * 100 / (maxEconomy - minEconomy) + "% 100%"
                        },
                        ref: economyRef,
                        type: "range",
                        min: 0,
                        max: 4,
                        list: "tickmarks_economy",
                        value: slider1Value,
                        onChange: (e)=>{
                            setSlider1Value(e.target.value);
                            setEconomyValue(economies[e.target.value].attributes.value);
                            setEconomyLabel(Number(economies[e.target.value].attributes.label));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tickmarks_economy",
                        children: economies.map((e)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                value: e.attributes.value,
                                label: e.attributes.label,
                                children: e.attributes.label
                            }, e.attributes.label))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: t("price.slider.frequency.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: frequencyRef,
                        type: "range",
                        style: {
                            backgroundSize: (parseInt(slider2Value) - minFrequency) * 100 / (maxFrequency - minFrequency) + "% 100%"
                        },
                        min: 0,
                        max: 2,
                        list: "tickmarks_frequency",
                        value: slider2Value,
                        onChange: (e)=>{
                            setSlider2Value(e.target.value), setFrequencyValue(frequency[e.target.value].attributes.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tickmarks_frequency",
                        children: frequency.map((f)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                value: f.attributes.value,
                                label: f.attributes.label,
                                children: f.attributes.label
                            }, f.attributes.label))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "price_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "price",
                        children: [
                            Math.floor(parseFloat(economyValue) * parseInt(economylabel) * parseInt(frequencyValue) * 12),
                            "€"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "price_description",
                        children: t("price.slider.description", {
                            price: "300"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "price_button",
                        href: "/checkout",
                        children: t("price.slider.button")
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/helpers/tracking.js
var tracking = __webpack_require__(8929);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/ZipCode/ZipCode.js






function ZipCode() {
    const [zipCode, setZipCode] = (0,react.useState)("");
    const [isEmpty, setIsEmpty] = (0,react.useState)(false);
    const zipCodeRegex = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;
    const [isNotValid, setIsNotValid] = (0,react.useState)(false);
    const [lang, setLang] = (0,react.useState)("");
    const errorRef = (0,react.useRef)(null);
    const inputRef = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    function checkZipCode(e) {
        e.preventDefault();
        axios/* default.get */.Z.get("".concat("https://api-staging.horsnorm.es", "/delivery/zipcheck/").concat(lang, "/").concat(zipCode.trim())).then((res)=>{
            if (res.data) {
                (0,tracking/* trackZipcodeEntered */.i)(zipCode, "home", lang, true);
                router.push("/baskets?zipcode=".concat(zipCode));
                localStorage.setItem("zipcode", JSON.stringify(zipCode));
                setIsEmpty(false);
            } else {
                (0,tracking/* trackZipcodeEntered */.i)(zipCode, "home", lang, false);
                setIsNotValid(true);
            }
        }).catch((error)=>{
            console.log(error);
        });
    }
    function limitDigits(input, maxDigits) {
        var _input_value;
        if ((input === null || input === void 0 ? void 0 : (_input_value = input.value) === null || _input_value === void 0 ? void 0 : _input_value.length) > maxDigits) {
            input.value = input.value.slice(0, maxDigits);
        }
    }
    function handleChange(e) {
        limitDigits(e.target.value, 5);
        setZipCode(e.target.value);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: (e)=>{
                    if (zipCode.match(zipCodeRegex)) {
                        checkZipCode(e);
                    }
                    if (!zipCode) {
                        var _inputRef_current;
                        setIsEmpty(true);
                        inputRef === null || inputRef === void 0 ? void 0 : (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
                    }
                },
                className: "zipcode",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        onChange: handleChange,
                        placeholder: t("input.zipcode.placeholder"),
                        ref: inputRef,
                        maxLength: 5,
                        inputMode: "numeric",
                        pattern: "[0-9]{5}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "submit",
                        className: "button_desktop",
                        value: t("button.baskets")
                    })
                ]
            }),
            isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "red",
                    margin: 0,
                    marginTop: "5px",
                    paddingLeft: "10px"
                },
                children: t("zipcode.error.format")
            }) : null,
            isNotValid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                onClick: ()=>{},
                ref: errorRef,
                className: "error_zipcode",
                children: [
                    t("error.message.delivery"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "signup_zipcode",
                        href: lang === "es" ? "https://tally.so/r/mVGLxj?cp=".concat(zipCode) : "https://tally.so/r/wQOVYm?cp=".concat(zipCode),
                        children: t("subscription.wait.list.link")
                    }),
                    t("susbcription.wait.list")
                ]
            }) : null
        ]
    });
}

// EXTERNAL MODULE: ./components/SingleArticle/SingleArticle.js
var SingleArticle = __webpack_require__(1081);
;// CONCATENATED MODULE: ./components/LatestArticle/LatestArticles.js






function LatestArticles() {
    var _articles_data;
    const [lang, setLang] = (0,react.useState)("");
    const [articles, setArticles] = (0,react.useState)([]);
    const { t  } = (0,esm/* useTranslation */.$G)();
    (0,react.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    (0,react.useEffect)(()=>{
        const fetchLatestPost = async ()=>{
            try {
                const { data  } = await axios/* default.get */.Z.get("".concat("https://strapi-staging.benebono.fr", "/api/blog-posts?sort=publishedAt:desc&populate=*&pagination[limit]=3&locale=").concat(lang === "es" ? lang : "fr-FR"));
                setArticles(data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchLatestPost();
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "latest_article_container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "latest_article_description",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: t("latest.article.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("latest.article.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog",
                        className: "latest_article_button",
                        children: t("latest.article.button")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "recommendation_articles",
                children: articles && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: articles === null || articles === void 0 ? void 0 : (_articles_data = articles.data) === null || _articles_data === void 0 ? void 0 : _articles_data.map((a)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleArticle/* default */.Z, {
                            data: a,
                            link: "blog"
                        }, a.id);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(8583);
// EXTERNAL MODULE: ./utils/helpers/store.js
var store = __webpack_require__(7104);
;// CONCATENATED MODULE: ./components/Truspilot/Trustpilot.js




function Trustpilot(param) {
    let { className  } = param;
    var _trustpilotData_local, _trustpilotData_local1;
    const local = (0,esm_react/* useAtomValue */.Dv)(store/* localeAtom */.S);
    const trustpilotData = {
        fr: {
            dataLocale: "fr-FR",
            dataBusinessUnitId: "63ecd8b58722793aa12cb53a"
        },
        es: {
            dataLocale: "es-ES",
            dataBusinessUnitId: "63fd05894493539d7dc81312"
        }
    };
    (0,react.useEffect)(()=>{
        var aScript = document.createElement("script");
        aScript.type = "text/javascript";
        aScript.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
        aScript.async = "true";
        document.head.appendChild(aScript);
        aScript.onload = function() {
            var trustbox = document.getElementById("trustbox");
            window.Trustpilot.loadFromElement(trustbox);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "trustbox",
            className: "trustpilot-widget",
            "data-locale": ((_trustpilotData_local = trustpilotData[local]) === null || _trustpilotData_local === void 0 ? void 0 : _trustpilotData_local.dataLocale) || trustpilotData.fr.dataLocale,
            "data-template-id": "5419b6ffb0d04a076446a9af",
            "data-businessunit-id": ((_trustpilotData_local1 = trustpilotData[local]) === null || _trustpilotData_local1 === void 0 ? void 0 : _trustpilotData_local1.dataBusinessUnitId) || trustpilotData.fr.dataBusinessUnitId,
            "data-style-height": "20px",
            "data-style-width": "100%",
            "data-theme": "light",
            "data-font-family": "Poppins"
        })
    });
}

;// CONCATENATED MODULE: ./components/SmartLink/SmartLink.jsx



/**
 * Component to render a `<a>` element if the link targets an external URL, and a `<Link>` component otherwise
 */ const SmartLink = (param)=>{
    let { href , children , className , ...props } = param;
    const isExternal = (0,react.useMemo)(()=>{
        if (!href) return false;
        return href.startsWith("http") || href.startsWith("https") || href.startsWith("//");
    }, [
        href
    ]);
    if (isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            className: className,
            target: "_blank",
            rel: "noopener noreferrer",
            ...props,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        className: className,
        ...props,
        children: children
    });
};
/* harmony default export */ var SmartLink_SmartLink = (SmartLink);

;// CONCATENATED MODULE: ./components/Catalog/Catalog.js
/* eslint-disable @next/next/no-img-element */ 



const categoryMapping = {
    Apéritifs: "appetizers",
    "Sauces, Condiments & \xc9pices": "sauces_condiments_and_spices",
    Bières: "beers",
    "Cuisines du monde": "world_cuisines",
    "Chocolats & Confiseries": "chocolates_and_sweets",
    "Biscuits & G\xe2teaux": "biscuits_and_cakes",
    "Fruits secs": "dried_fruits",
    "Conserves & Bocaux": "preserves_and_jars",
    "P\xe2tes, Riz & C\xe9r\xe9ales": "pasta_rice_and_cereals",
    "Plats cuisin\xe9s & Soupes": "ready_meals_and_soups",
    "Desserts & Compotes": "desserts_and_compotes",
    "Caf\xe9, Th\xe9 & Boissons chaudes": "coffee_tea_and_hot_drinks",
    "Cr\xe8merie & Fromages": "dairy_and_cheeses",
    "P\xe2tes \xe0 tartiner, Confitures & Miels": "spreads_jams_and_honey",
    "Laits & Boissons v\xe9g\xe9tales": "milks_and_plant_drinks",
    "C\xe9r\xe9ales & Biscottes": "cereal_and_rusk"
};
function getCategory(slug, inEditor) {
    if (slug === "home" || slug === "catalog") {
        return slug;
    }
    if (inEditor) {
        return Object.values(categoryMapping)[0];
    }
    if (slug && Object.values(categoryMapping).includes(slug)) {
        return slug;
    }
    //should we have a default ?
    return null;
}
function Catalog(props) {
    const { children , className  } = props;
    const plasmicCategory = props.category;
    const inEditor = (0,react.useContext)(index_esm/* PlasmicCanvasContext */.y1);
    const category = getCategory(plasmicCategory, inEditor);
    const { data , error  } = (0,index_esm/* usePlasmicQueryData */.UX)([
        "categories",
        category
    ], async ()=>{
        const apiUrl = "".concat("https://api-staging.horsnorm.es", "/categories/products");
        const resp = await fetch(apiUrl, {
            cache: "no-store"
        });
        if (!resp.ok) {
            throw new Error("\xc9chec de l'appel API");
        }
        const fetchedData = await resp.json();
        if (fetchedData && category === "home") {
            const firstProductsArray = fetchedData.data.map((item)=>{
                if (Array.isArray(item.products) && item.products.length > 0) {
                    return item.products[0];
                }
                return null;
            });
            return {
                products: firstProductsArray,
                categoryName: "home",
                allCategoryName: []
            };
        }
        if (fetchedData && category) {
            const dataParse = fetchedData.data.filter((cat)=>Object.keys(categoryMapping).includes(cat.category.category)).map((cat)=>({
                    category: categoryMapping[cat.category.category] || cat.category.category,
                    categoryName: cat.category.category,
                    image: cat.category.image,
                    products: cat.products
                }));
            const allCategoryName = dataParse.map((cat)=>({
                    categoryName: cat.categoryName,
                    imgCategory: cat.image,
                    categoryPath: "/catalog/".concat(cat.category)
                }));
            allCategoryName.sort((a, b)=>a.categoryName.localeCompare(b.categoryName));
            const matchedCategory = dataParse.find((item)=>item.category === category);
            while((matchedCategory === null || matchedCategory === void 0 ? void 0 : matchedCategory.products.length) < 50){
                const newProduct = JSON.parse(JSON.stringify(matchedCategory.products[0]));
                newProduct.title = ((matchedCategory === null || matchedCategory === void 0 ? void 0 : matchedCategory.products.length) + 1).toString();
                matchedCategory.products.push(newProduct);
            }
            return {
                products: (matchedCategory === null || matchedCategory === void 0 ? void 0 : matchedCategory.products) || [],
                categoryName: (matchedCategory === null || matchedCategory === void 0 ? void 0 : matchedCategory.categoryName) || "",
                allCategoryName
            };
        }
        return {
            products: [],
            categoryName: "",
            allCategoryName: []
        };
    });
    if (error) {
        console.error("Erreur de r\xe9cup\xe9ration :", error);
        return null;
    }
    if (!data || data.products.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DataProvider */.FW, {
        name: "catalog",
        data: {
            products: data.products,
            categoryName: data.categoryName,
            allCategoryName: data.allCategoryName
        },
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: children
        })
    });
}

// EXTERNAL MODULE: ./components/Storifyme/Storifyme.jsx
var Storifyme = __webpack_require__(3818);
;// CONCATENATED MODULE: ./components/HomePageCatalog/HomePageCatalog.js
/* eslint-disable @next/next/no-img-element */ 



function HomePageCatalog(props) {
    const { children , className  } = props;
    // Salé et sucré IDs
    const excludedCategoryIds = [
        44,
        39
    ];
    // fresh categories IDs
    const freshTags = [
        "fresh_product_V1",
        "fresh"
    ];
    const weeklyPotagerId = "Potager de la semaine";
    const groceryNature = "grocery";
    function shouldNotExcludeCategory(cat) {
        return !excludedCategoryIds.includes(cat.category.id);
    }
    const isCategoryFresh = (category)=>{
        var _category_tags;
        return (_category_tags = category.tags) === null || _category_tags === void 0 ? void 0 : _category_tags.some((tag)=>freshTags.includes(tag));
    };
    const isCategoryWeeklyPotager = (category)=>{
        return category.categoryName === weeklyPotagerId;
    };
    const isNotGrocery = (product)=>product.nature !== groceryNature;
    const { data , error  } = (0,index_esm/* usePlasmicQueryData */.UX)("categories", async ()=>{
        const apiUrl = "".concat("https://api-staging.horsnorm.es", "/categories/products");
        const resp = await fetch(apiUrl, {
            cache: "no-store"
        });
        const fetchedData = await resp.json();
        if (fetchedData) {
            const dataParse = fetchedData.data.filter(shouldNotExcludeCategory).sort((catA, catB)=>catA.category.rank - catB.category.rank).map((cat)=>{
                var _cat_category;
                return {
                    categoryName: cat.category.category,
                    tags: (_cat_category = cat.category) === null || _cat_category === void 0 ? void 0 : _cat_category.tags,
                    image: cat.category.image,
                    products: cat.products
                };
            });
            // Transformation pour créer les nouvelles catégories "Grocery" et "Frais"
            const newGroceryProducts = [];
            const newFreshProducts = [];
            const newFruitsAndVegetableProducts = [];
            dataParse.forEach((categoryObj)=>{
                if (isCategoryWeeklyPotager(categoryObj)) {
                    newFruitsAndVegetableProducts.push(...categoryObj.products.slice(0, 26));
                    return;
                }
                if (isCategoryFresh(categoryObj)) {
                    newFreshProducts.push(...categoryObj.products.filter(isNotGrocery).slice(0, 3));
                    return;
                }
                newGroceryProducts.push(...categoryObj.products.slice(0, 2));
            });
            const newCategories = [
                {
                    category: "\xc9picerie",
                    products: newGroceryProducts
                },
                {
                    category: "Produits Frais",
                    products: newFreshProducts
                },
                {
                    category: "Fruits et l\xe9gumes",
                    products: newFruitsAndVegetableProducts
                }
            ];
            const allCategoryName = newCategories.map((cat)=>({
                    categoryName: cat.category
                }));
            return {
                products: newCategories,
                allCategoryName
            };
        }
    });
    if (error) {
        console.error("Erreur de r\xe9cup\xe9ration :", error);
        return null;
    }
    if (!data || data.products.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DataProvider */.FW, {
        name: "HomePageCatalog",
        data: {
            products: data.products,
            categoryName: data.categoryName,
            allCategoryName: data.allCategoryName
        },
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./plasmic-init.js
/* provided dependency */ var process = __webpack_require__(3454);









const PLASMIC = (0,index_esm/* initPlasmicLoader */.fZ)({
    projects: [
        {
            id: process.env.PLASMIC_PROJECT_ID,
            token: process.env.PLASMIC_API_TOKEN,
            version: process.env.PLASMIC_ENV === "production" ? "prod" : process.env.PLASMIC_ENV === "staging" ? "staging" : undefined
        }
    ],
    // PUT TO FALSE IN PRODUCTION TO AVOID CHANGES TO BE DONE EVEN WHEN IT'S UNPUBLISHED
    preview: process.env.PLASMIC_ENV === "production" ? false : process.env.PLASMIC_ENV === "staging" ? false : true
});
PLASMIC.registerComponent(PriceSlider, {
    name: "PriceSlider",
    displayName: "Price Slider",
    props: {
        backgroundColor: "cssColor"
    },
    defaultStyles: {
        width: "100%"
    }
});
PLASMIC.registerComponent(ZipCode, {
    name: "ZipCode",
    displayName: "ZipCode Input",
    props: {}
});
PLASMIC.registerComponent(LatestArticles, {
    name: "LatestArticles",
    displayName: "Latest Articles",
    props: {},
    defaultStyles: {
        width: "100%"
    }
});
PLASMIC.registerComponent(Trustpilot, {
    name: "Trustpilot",
    displayName: "Trustpilot",
    props: {},
    defaultStyles: {
        width: "100%"
    }
});
PLASMIC.registerComponent(Storifyme/* default */.Z, {
    name: "Storifyme",
    displayName: "Storifyme",
    props: {
        widgetID: "string"
    }
});
PLASMIC.registerComponent(SmartLink_SmartLink, {
    name: "SmartLink",
    props: {
        href: "string",
        children: "slot",
        className: "string"
    }
});
PLASMIC.registerComponent(Catalog, {
    name: "Catalog",
    props: {
        category: "string",
        children: "slot"
    },
    providesData: true
});
PLASMIC.registerComponent(HomePageCatalog, {
    name: "HomePageCatalog",
    props: {
        category: "string",
        children: "slot"
    },
    providesData: true
});


/***/ }),

/***/ 8929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ trackZipcodeEntered; }
/* harmony export */ });
function trackZipcodeEntered(zipcode, page, country, area_opened) {
    var _window_rudderanalytics;
    window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.track("Zipcode Entered", {
        zipcode,
        page,
        country,
        area_opened
    });
}


/***/ })

}]);